export default function Main({ children }) {
  return <main className='main'>{children}</main>;
}
